<template>
  <div style="height:15%;width:100%; display: flex;flex-direction:row;flex-wrap: wrap;justify-content:center;">
     
      <div  style="width: 20%;display: flex;flex-direction:row;flex-wrap: wrap;justify-content:center;margin-top:5px;font-size:30px;font-weight: bold;color:#111">
        <div style="color:#970B0B;margin:10px;">用户数量: {{sysTotal.userTotal}}</div>

      </div>

      <div  style="width: 20%;display: flex;flex-direction:row;flex-wrap: wrap;justify-content:center;margin-top:5px;font-size:30px;font-weight: bold;color:#111">

         <div style="color:#970B0B;margin:10px;">设备数量: {{sysTotal.deviceTotal}}</div>
         <div style="color:#970B0B;margin:10px;">在线设备: {{sysTotal.onlineTotal}}</div>
         <div style="color:#970B0B;margin:10px;">离线设备: {{sysTotal.offlineTotal}}</div>
      </div>
      <div  style="width: 20%;display: flex;flex-direction:row;flex-wrap: wrap;justify-content:center;margin-top:5px;font-size:30px;font-weight: bold;color:#111">
        <div style="color:#970B0B;margin:10px;">售卖设备: {{sysTotal.soldTotal}}</div>

         <div style="color:#970B0B;margin:10px;">已售设备: {{sysTotal.sold}}</div>
         <div style="color:#970B0B;margin:10px;">未售设备: {{sysTotal.unsold}}</div>
      </div>



<div style="background-color:#fff;width:100%; height:450px">
    <div id="echartBar" style="width:100%; height:450px"></div>

</div>
 
  

<div style="height:40px"></div>






  </div>
</template>




<script>

import TMApipath from 'TMApipath'
import TMStore from 'TMStore'
import TMConfig from 'TMConfig'
var echarts = require('echarts')
import {randomWord,randomWordAll,formatTimestamp,formatTime,isJsonType} from 'TMUtils'


  export default {
    methods: {
      
    
      getTotaldeviceSales(){

          var _this = this

          var reqdata = {}  
          var {urls} = _this.getresult(TMApipath.DEVICECUSTOMER, TMApipath.URL_API_GETTOTAL, reqdata);


           let loadingInstance = _this.$loading({ fullscreen: true ,text:"Loading"});


          _this.axios.get(urls,reqdata ).then((response) => {
            _this.$nextTick(() => {  loadingInstance.close(); });
            if (response.status ) {
              // vuex记录

                _this.sysTotal.unsold =response.data.unsold;
                _this.sysTotal.sold =response.data.sold;
                _this.sysTotal.soldTotal =response.data.sold +response.data.unsold;



            }else{
              this.$message.error(response.msg);
            }
          }, (response) => {
            _this.$nextTick(() => {  loadingInstance.close(); });
            console.log(response)
          });

      },
    
      getTotaldevice(){

          var _this = this

          var reqdata = {}  
          var {urls} = _this.getresult(TMApipath.DEVICEHISTORY, TMApipath.URL_API_GETTOTAL, reqdata);


           let loadingInstance = _this.$loading({ fullscreen: true ,text:"Loading"});


          _this.axios.get(urls,reqdata ).then((response) => {
            _this.$nextTick(() => {  loadingInstance.close(); });
            if (response.status ) {
              // vuex记录

                _this.sysTotal.deviceTotal =response.data.deviceTotal;
                _this.sysTotal.onlineTotal =response.data.onlineTotal;
                _this.sysTotal.offlineTotal =response.data.deviceTotal -response.data.onlineTotal;


            }else{
              this.$message.error(response.msg);
            }
          }, (response) => {
            _this.$nextTick(() => {  loadingInstance.close(); });
            console.log(response)
          });

      },
      getTotaluser(){

          var _this = this

          var reqdata = {}  
          var {urls} = _this.getresult(TMApipath.USER, TMApipath.URL_API_GETTOTAL, reqdata);


           let loadingInstance = _this.$loading({ fullscreen: true ,text:"Loading"});


          _this.axios.get(urls,reqdata ).then((response) => {
            _this.$nextTick(() => {  loadingInstance.close(); });
            if (response.status ) {
              // vuex记录

                _this.sysTotal.userTotal =response.data.serTotal;


            }else{
              this.$message.error(response.msg);
            }
          }, (response) => {
            _this.$nextTick(() => {  loadingInstance.close(); });
            console.log(response)
          });

      },
      getOnlineHistory(){

          var _this = this

          var reqdata = {timetype:'6h'}  
          var {urls} = _this.getresult(TMApipath.DEVICEHISTORY, TMApipath.URL_API_GETONLINEHISTORY, reqdata);


           let loadingInstance = _this.$loading({ fullscreen: true ,text:"Loading"});


          _this.axios.get(urls,reqdata ).then((response) => {
            _this.$nextTick(() => {  loadingInstance.close(); });
            if (response.status ) {
              // vuex记录

                  var xAxisData = []
                  var seriesData = []
                  var onlineList = response.data.online
                  for (let index = 0; index < onlineList.length; index++) {
                    const element = onlineList[index];
                    xAxisData.push(formatTimestamp(element.createDate))
                    seriesData.push(element.devicecount)
                  }
                  
                    _this.xAxisData = xAxisData.reverse()
                    _this.seriesData = seriesData.reverse()


                 _this.initChart();


            }else{
              this.$message.error(response.msg);
            }
          }, (response) => {
            _this.$nextTick(() => {  loadingInstance.close(); });
            console.log(response)
          });

      },
      initChart(){
                  var _this = this

         // 基于准备好的dom，初始化echarts实例
          var myChart = echarts.init(document.getElementById('echartBar'));
          // 绘制图表
          myChart.setOption({
              tooltip: {
                show: true,
                trigger: 'axis',
                formatter: ' 时间: {b0} 在线: {c0}',

              },
              xAxis: {
                type: 'category',
                data: _this.xAxisData
              },
              yAxis: {
                type: 'value',
                max: function (value) {
                  return _this.sysTotal.deviceTotal;
              },
              },
              series: [
                {
                  data: _this.seriesData,
                  type: 'line',
                  smooth: true
                }
              ]
          });
      }


    },
    beforeDestroy(){
      var _this = this

        // 关掉已有的socket链接
        _this.connectStatus = '已断开';
        _this.connetIsOpen = false;
        _this.socket.close();
        clearTimeout(_this.heartBeatTimeOut);
        _this.socketClose = true;
        _this.stopHeartBeat();
    },
    mounted() {

      var _this = this
      this.token = TMStore.state.account.token
      this.aid = TMStore.state.account.aid 
      this.username = TMStore.state.account.username 

      this.getTotaldeviceSales()

      this.getTotaldevice()
      this.getTotaluser()
      this.getOnlineHistory()


      _this.initChart();


    },
    data() {
      return {
         
          message:'',
          loadingInstance:'',
          sysTotal:{
            soldTotal: '--',
            sold: '--',
            unsold: '--',

            deviceTotal: '--',
            onlineTotal: '--',
            offlineTotal: '--',
            userTotal: '--'
          },
          aid: '',
          token:'',
          cid:'',
          username:'',
          updateDate:'',
       
          seriesData:[],
          xAxisData:[],
          
    
      }
    }
  }
</script>

<style scoped>
img {
  margin-top: 10px;
  display: flex;
  width: 90px; 
  height: 90px;
  justify-content: space-between;

}
.gbtn {
  margin-left: 19px;
  margin-top: 20px;
  margin: 20px
} 

</style>